var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41005 0H12.5901C12.7878 0.00082923 12.9809 0.060284 13.1449 0.170847C13.3089 0.281409 13.4364 0.438115 13.5113 0.621147C13.5862 0.804179 13.6052 1.00532 13.5658 1.19913C13.5264 1.39294 13.4305 1.57073 13.2901 1.71L7.71005 7.28999C7.61709 7.38372 7.50649 7.45811 7.38463 7.50888C7.26277 7.55965 7.13207 7.58578 7.00005 7.58578C6.86804 7.58578 6.73734 7.55965 6.61548 7.50888C6.49362 7.45811 6.38302 7.38372 6.29005 7.28999L0.710053 1.71C0.569632 1.57073 0.473661 1.39294 0.434275 1.19913C0.39489 1.00532 0.413859 0.804179 0.488785 0.621147C0.563711 0.438115 0.691228 0.281409 0.855211 0.170847C1.01919 0.060284 1.21228 0.00082923 1.41005 0Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderDownIcon);
export default __webpack_public_path__ + "static/media/CalenderDownIcon.4ab923d3a4f72ffbe8c0409ea57f1970.svg";
export { ForwardRef as ReactComponent };